import React from "react";
import { Card, Alert } from "react-bootstrap";

function ManagingVariables() {
  return (
    <div>
      <h2 className="mb-4">Managing Variables</h2>

      <Alert variant="info">
        Learn how to create, edit, and delete variable data entries.
      </Alert>

      <Card className="mb-4">
        <Card.Body>
          <h4>Viewing Variable Data</h4>
          <ol>
            <li>Go to <strong>My Variables</strong></li>
            <li>Click on any variable in the grid</li>
            <li>You'll be taken to the Variable Lines page showing all data entries for that variable</li>
          </ol>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Adding a New Variable Line</h4>
          <ol>
            <li>From the Variable Lines page, click <strong>Add Variable Line</strong></li>
            <li>Enter the key and value for the new data entry</li>
            <li>Click <strong>Save</strong></li>
            <li>The new data will be immediately available to runbooks</li>
          </ol>
          <p className="mt-3">
            <em>Note: You need the "variables.create" permission to add variable lines.</em>
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Editing a Variable Line</h4>
          <ol>
            <li>From the Variable Lines page, select the line you want to edit</li>
            <li>Click the <strong>Edit</strong> button</li>
            <li>Modify the key or value</li>
            <li>Click <strong>Save</strong></li>
          </ol>
          <p className="mt-3">
            <em>Note: Changes take effect immediately. Any runbooks using this variable will see the updated values.</em>
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Deleting a Variable Line</h4>
          <ol>
            <li>From the Variable Lines page, select the line you want to delete</li>
            <li>Click the <strong>Delete</strong> button</li>
            <li>Confirm the deletion</li>
          </ol>
          <p className="mt-3">
            <strong>Warning:</strong> If any runbooks are currently using this data, they may fail or produce
            unexpected results after deletion.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Searching Variable Data</h4>
          <p>
            Use the search filter to find specific variable lines by key or value. This is helpful when working
            with variables that contain many data entries.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Best Practices</h4>
          <ul>
            <li>Use descriptive keys that clearly indicate what the value represents</li>
            <li>Keep related data together in the same variable</li>
            <li>Document what each variable is used for</li>
            <li>Be careful when deleting or modifying data - check if runbooks are using it first</li>
            <li>Use consistent naming conventions for keys</li>
          </ul>
        </Card.Body>
      </Card>
    </div>
  );
}

export default ManagingVariables;
